<template>
  <div class="c-device">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ODevicePreview'
}
</script>

<style lang="scss">
.c-device {
  box-shadow: 0 0 0 0.1rem rgba($blue-dark, 0.1),
    0 4rem 8rem rgba($blue-dark, 0.25);
  height: 64.8rem;
  margin: auto;
  overflow: hidden;
  position: relative;
  width: 41.2rem;
}

@media (max-width: 26em) {
  .c-device {
    box-shadow: none;
    height: 100%;
    margin: 0;
    width: 100%;
  }
}
</style>
